import React, { useEffect, useState, useRef } from 'react';
import { Icon } from '../../../assets/icons';
import { Modal } from '../../modals';
import { NavLink } from 'react-router-dom';
import useOutsideClick from '../../../hooks/useOutsideClick';

const DropdownMenu = ({ button, options, data }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [menuOptions, setMenuOptions] = useState(options)
  const [modal, setModal] = useState("")
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dropdownRef = useRef(null); // Reference to the dropdown element

  useEffect(() => {
    setMenuOptions(options);
  }, [options]);


  const openModal = (option) => {
    setModal(option.modal)
    setIsModalOpen(true);
    // closeDropdown()
    // toggleDropdown()
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };


  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const closeDropdown = () => {
    setIsOpen(false);
  };
  useOutsideClick(dropdownRef, closeDropdown);
  return (
    <div ref={dropdownRef} className=" relative inline-block text-left  min-w-fit ">
      <button
        onClick={toggleDropdown}
        type="button"
        className="inline-flex space-x-1 items-center min-w-fit p-1 text-sm font-medium  rounded-md focus:outline-none  "
      >
        <div className='min-w-fit'>
          {button.text && button.text}
        </div>
        <div>
          {button.icon && <Icon icon={button.icon} />}

        </div>
      </button>

      {isOpen && (
        <div className=" z-10 origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
          <div
            className="py-1"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="options-menu"
          >
            {modal && <Modal modal={modal} data={data} isOpen={isModalOpen} onClose={closeModal} />}
            {menuOptions.map((option, i) => (
              <div key={i}>
                {/* <Modal modal={option.modal} isOpen={isEditModalOpen} onClose={closeModal} /> */}
                {option.divider &&
                  <hr className="my-1 border-gray-100" />}
                {option.info &&
                  <div
                    className="flex w-full items-center space-x-2 px-4 py-2 text-sm text-gray-700"
                  >
                    <div>
                      {option.icon && <Icon icon={option.icon} />}
                    </div>
                    <div>
                      {option.title}
                    </div>
                  </div>}
                {option.modal &&
                  <button
                    key={option.title}
                    className={`flex w-full font-semibold space-x-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 ${option.disabled ? 'cursor-not-allowed' : ''}`}
                    onClick={() => openModal(option)}
                    disabled={option.disabled}
                  >
                    <div>
                      {option.icon && <Icon icon={option.icon} />}
                    </div>
                    <div>
                      {option.title}
                    </div>
                  </button>}
                {option.onClick &&
                  <button
                    key={option.title}
                    className={`flex w-full font-semibold space-x-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 ${option.disabled ? 'cursor-not-allowed' : ''}`}
                    onClick={() => { option.onClick(); closeDropdown(); }}
                    disabled={option.disabled}
                  >
                    <div>
                      {option.icon && <Icon icon={option.icon} />}
                    </div>
                    <div>
                      {option.title}
                    </div>
                  </button>
                }

                {option.path &&
                  <NavLink
                    to={option.path}
                    onClick={() => closeDropdown()}
                    className=" w-full text-sm font-semibold transition-colors duration-150 text-side_bar_txt"
                  >
                    <button


                      key={option.title}
                      className="flex w-full space-x-2 px-4 py-2  text-sm text-gray-700 hover:bg-gray-100"
                    >
                      <div>
                        {option.icon && <Icon icon={option.icon} />}
                      </div>
                      <div>
                        {option.title}
                      </div>
                    </button>
                  </NavLink>}
                {option.disabled &&
                  <div
                    key={option.title}
                    className="flex w-full font-semibold space-x-2 px-4 py-2 text-sm text-gray-400 cursor-not-allowed"
                  >
                    <div>
                      {option.icon && <Icon icon={option.icon} />}
                    </div>
                    <div>
                      {option.title}
                    </div>
                  </div>}
                {/* {option.selecte &&
                  <button
                    key={option.title}
                    className="flex w-full  font-semibold space-x-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      {option.selecte}
                  </button>
                } */}

              </div>
            ))}


          </div>
        </div>
      )}
    </div>
  );
};

export default DropdownMenu;